import { useNavigate } from 'react-router-dom';
import { clearStore } from 'v3/data/store';
import { RoutesEnum } from 'v3/routes/enum';

export const useHandleOnExitClick = () => {
  const navigate = useNavigate();

  const handleOnExitClick = () => {
    sessionStorage.clear();
    navigate(RoutesEnum.Home, { replace: true });
    clearStore();
    window.location.reload();
  };

  return { handleOnExitClick };
};
